import postLoginByEmail from '@/fetches/user/auth/post-login-by-email';
import useAlert from '@/hooks/use-alert';
import useSelectorUser from '@/hooks/use-selector-user';
import { actions } from '@/store';
import { EAuthModalPage } from '@/store/types';
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Message from '@/constant/message';
import { Anchor, AnchorText } from '../common/anchor-text';
import { AuthButton } from '../common/auth-button';
import { AuthTitle } from '../common/auth-title';
import { EmailBox } from '../common/email-box';
import { InputText } from '../common/input-text';

/** 비밀번호 입력 */
export const InputPassword: React.FC = () => {
  const { email } = useSelectorUser('authModal');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { alert } = useAlert();
  const { t } = useTranslation();
  const onChangePasswordInput = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.currentTarget.value);
    setError('');
  }, []);

  const submitPassword = useCallback(async () => {
    if (!password) {
      setError(t(Message.비밀번호를입력하세요));
      return;
    }
    setLoading(true);
    const { data, error: err, deletedAt } = await postLoginByEmail(email, password);
    if (data) {
      dispatch(actions.user.authModal.setToken(data));
      dispatch(actions.user.authModal.setCurrentPage(EAuthModalPage.SUCCESS));
    } else if (err === 'too many failure') {
      await alert(
        t(Message.비밀번호를5회이상잘못입력하셨습니다비밀번호찾기를통해비밀번호를변경해주세요),
        t(Message.비밀번호재설정),
      );
      dispatch(actions.user.authModal.setConfirmCodeType('pwreset'));
      dispatch(actions.user.authModal.setCurrentPage(EAuthModalPage.SEND_EMAIL_AND_INPUT_CONFIRM_CODE));
    } else if (err === 'incorrect password') {
      setError(t(Message.비밀번호가일치하지않습니다));
    } else if (err === 'member is pending deletion') {
      dispatch(actions.user.authModal.setDeletedAt(deletedAt!));
      dispatch(actions.user.authModal.setCurrentPage(EAuthModalPage.WILL_BE_DELETED_ACCOUNT));
    } else if (err === 'internal server error') {
      alert(t(Message.처리도중서버에서오류가발생했습니다잠시후다시시도하시거나관리자에게문의해주세요));
    } else {
      alert(t(Message.처리도중서버에서오류가발생했습니다잠시후다시시도하시거나관리자에게문의해주세요));
    }
    setLoading(false);
  }, [alert, dispatch, email, password, t]);

  const findPasswordButton = useCallback(() => {
    dispatch(actions.user.authModal.setConfirmCodeType('pwreset'));
    dispatch(actions.user.authModal.setCurrentPage(EAuthModalPage.SEND_EMAIL_AND_INPUT_CONFIRM_CODE));
  }, [dispatch]);

  return (
    <>
      <AuthTitle>{t(Message.로그인)}</AuthTitle>
      <EmailBox>{email}</EmailBox>
      <InputText
        type="password"
        title={t(Message.비밀번호를입력하세요)}
        errorText={error}
        value={password}
        disabled={loading}
        autoFocus
        onPressEnter={submitPassword}
        onChange={onChangePasswordInput}
      />
      <AuthButton type="button" onClick={submitPassword} disabled={loading}>{t(Message.확인)}</AuthButton>
      <AnchorText as="span">{t(Message.비밀번호를잊으셨나요)}</AnchorText>
      <Anchor onClick={findPasswordButton}>{t(Message.비밀번호재설정)}</Anchor>
    </>
  );
};
